module.exports = __webpack_public_path__ + "img/bus-transports.6c59e1d3.webp";